import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';

/* Beam table upload API is a 3 step process and goes as follows:
    1. Perform a PUT operation to {{api_hostname}}/{{sw_manager}}/beamtables. Receive the upload URL and upload status URL
    2. Upload file to the upload URL
    3. Tell the upload status URL that the download has completed

*/

/* Step 1. Performs a PUT with beamtable info to receive URLS*/
function beamTableUploadHelper1() {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'Content-Type': 'application/json',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Accept-Encoding': 'gzip, deflate'
  };

  const url = apiConfig.swManagerPutUploadBeamTable();

  return fetch(url, { method: 'PUT', headers: headers }).then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  });
}

/* Step 2. Upload file, wait for upload to finish */
function beamTableUploadHelper2(file, url, progressCallback) {
  const headers = {
    'cache-control': 'no-cache',
    'x-ms-blob-type': 'BlockBlob'
  };

  let request = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    request.onreadystatechange = () => {
      if (request.readyState !== 4) {
        return;
      }
      if (request.status >= 200 && request.status <= 300) {
        resolve(request);
      } else {
        reject({
          message: request.status
        });
      }
    };

    request.upload.addEventListener(
      'progress',
      (evt) => {
        if (evt.lengthComputable) {
          console.log(evt.loaded + ' / ' + evt.total);
          progressCallback(evt);
        }
      },
      false
    );

    request.open('PUT', url);

    Object.keys(headers).forEach((key) => {
      request.setRequestHeader(key, headers[key]);
    });

    request.send(file);
  });
}

function beamTableUploadHelper3(url) {
  const auth = window.__APP_AUTH;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Accept-Encoding': 'gzip, deflate'
  };

  const data = {
    eventName: 'uploadCompleted'
  };

  return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(data) }).then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  });
}

export async function putUploadBeamTable(file, progressCallback, versionString = '') {
  try {
    const res1 = await beamTableUploadHelper1().catch((e) => {
      throw e;
    });

    console.log('Uploading file to azure, res1:', res1, file);
    await beamTableUploadHelper2(file, res1.uploadURL, progressCallback).catch((e) => {
      console.error(e);
      throw e;
    });

    return beamTableUploadHelper3(res1.updateUploadStatusURL).catch((e) => {
      throw e;
    });
  } catch (e) {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        console.log(e);
        throw e;
    }
  }
}
